module.exports = __webpack_public_path__ + "static/img/086_TO8_1740_og.c6f535e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/086_TO8_1740_og.jpg
// module id = 3dfJ
// module chunks = 0